import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.secondary.superLight}`,
    backgroundColor: theme.palette.primary.contrastText,
    transition: 'border-color 0.15s, box-shadow 0.15s',
    '&:hover': {
      boxShadow: theme.shadows[2],
    },
  },
  cardActive: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    backgroundColor: theme.palette.primary.light,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(0.5),
  },
  seeMoreBox: {
    display: 'flex',
    justifyContent: 'right',
  },
  seeMoreButton: {
    marginTop: 'auto',
    fontSize: 12,
    fontWeight: 600,
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    borderRadius: 30,
    color: theme.palette.secondary.main,
    textTransform: 'none',
    padding: theme.spacing(0.25, 1),
    minWidth: 0,
    '&:hover': {
      textDecoration: 'none',
      opacity: 0.8,
    },
  },
}))

export default useStyles
